export default "/images/vendor/flag-icons/flags/1x1/gw.svg?eb6624eb4396d05c27c3cec5bc701d26";